import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { TooltipDisplayParameters } from './graph-base';

@Component({
  selector: 'prlw-abstract-graph-tooltip',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export abstract class AbstractGraphTooltipComponent<T> {
  @Input() public data!: T;
  @Input() public displayParams!: TooltipDisplayParameters;

  @HostBinding('style.display')
  public get display(): string {
    return this.displayParams.visible ? 'block' : 'none';
  }

  @HostBinding('style.left')
  public get left(): string {
    return `${this.displayParams.left}px`;
  }

  @HostBinding('style.top')
  public get top(): string {
    return `${this.displayParams.top}px`;
  }

  @HostBinding('class')
  public get align(): string {
    return `${this.displayParams.xAlign}-${this.displayParams.yAlign}`;
  }
}
